/**
 * WebSiteJsonLd — unlocks the Google sitelinks search box.
 *
 * When `getturfpulse.com` is searched directly, Google can render an
 * inline search bar that goes straight to /try?q={query}. This is the
 * schema that opts you in.
 *
 * Schema reference: https://schema.org/WebSite#sitelinks-searchbox
 */
import { Helmet } from 'react-helmet-async';

const SITE = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'TurfPulse',
  alternateName: 'TurfPulse — Smart Lawn Care',
  url: 'https://getturfpulse.com',
  publisher: {
    '@type': 'Organization',
    name: 'Hi Tex Lawn Pro LLC',
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://getturfpulse.com/try?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export const WebSiteJsonLd = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(SITE)}</script>
  </Helmet>
);

export default WebSiteJsonLd;
